import './DataTableColumnsSectionHeader.css';
export var sectionHeader = '_1o0bw490-3-12-1';
export var sectionHeaderLabel = '_1o0bw491-3-12-1';